import React, { ChangeEvent, memo, ReactNode, FC } from 'react'

interface LabelWrapperProps {
  canClickLabel: boolean
  children: ReactNode
  label: ReactNode
  id: string
  className?: string
}

const LabelWrapper: FC<LabelWrapperProps> = ({ canClickLabel, children, className, id, label }) => {
  return canClickLabel ? (
    <label data-test={`${label}-label`} className={`${className} label`} htmlFor={id}>
      <span>{children}</span>
      {label}
    </label>
  ) : (
    <span data-test={`${label}-label`} className={className}>
      {children}
      <label htmlFor={id}>{label}</label>
    </span>
  )
}

interface RadioProps {
  label: ReactNode
  id: string
  name?: string
  value: string | number
  'data-test'?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  disabled?: boolean
  className?: string
  canClickLabel?: boolean
}

/** @deprecated */
export const Radio = memo<RadioProps>(props => {
  const {
    canClickLabel = false,
    checked,
    className = '',
    disabled = false,
    id,
    label,
    name,
    onChange,
    value,
  } = props

  const changeInputHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e)
  }

  return (
    <LabelWrapper
      canClickLabel={canClickLabel}
      label={label}
      id={id}
      className={`flex items-center ${className}`}>
      <input
        type='radio'
        data-test={props['data-test'] ?? 'radio-input'}
        name={name}
        value={value}
        checked={checked}
        onChange={changeInputHandler}
        disabled={disabled}
        id={id}
        required
        className='deprecated-radio'
      />
    </LabelWrapper>
  )
})
